<template>
    <v-card v-if="order">
            <v-card-text class="pa-4">
                <div class="container my-4">
                    <v-row>
                        <v-col class="py-0">
                            <p class="my-0 subtitle-1 font-weight-bold">
                                Exchange Rate
                            </p>
                        </v-col>
                        <v-col class="text-right py-0">
                            <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                                1 {{ order.matcher_currency}} = {{ exchangeRate.toFixed(5) }} {{ order.poster_currency }}
                            </p>
                        </v-col>
                    </v-row>
                </div>
                <v-form>
                    <v-text-field
                        v-model="youSend"
                        outlined
                        label="You send"
                        name="you send"
                        v-validate="`required|min_value:1|max_value:${order.matcher_amount}`"
                        :suffix="order.matcher_currency"
                        :error-messages="errors.first('you send')"
                    />
                    <v-text-field
                        v-model="recipientGets"
                        outlined
                        label="Recipient Gets"
                        name="recipient gets"
                        v-validate="`required|min_value:1|max_value:${order.poster_amount}`"
                        :suffix="order.poster_currency"
                        :error-messages="errors.first('recipient gets')"
                    />
                </v-form>
            </v-card-text>

            <v-card-actions class="pa-4">
                <v-spacer/>
                <v-btn
                    class="px-6"
                    text
                    color="red darken-2"
                    large
                    @click="cancel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    class="px-6"
                    color="primary"
                    dark
                    depressed
                    large
                    @click="confirm"
                >
                    Confirm
                </v-btn>
            </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            amount: null,
        };
    },
    computed: {
        exchangeRate() {
            return this.order.poster_amount / this.order.matcher_amount;
        },
        youSend: {
            get() {
                return this.round(this.amount / this.exchangeRate);
            },
            set(v) {
                this.amount = this.round(v * this.exchangeRate)
            },
        },
        recipientGets: {
            get() {
                return this.round(this.amount);
            },
            set(v) {
                this.amount = this.round(v);
            },
        },
    },
    methods: {
        round(x, d = 100) {
            return Math.round(x * d) / d;
        },
        cancel() {
            this.amount = null;
            this.$emit('cancel');
        },
        confirm() {
            this.$emit('confirm', this.amount);
        },
    },
};
</script>
